import { render, staticRenderFns } from "./AdminSalesSummary.vue?vue&type=template&id=18b889bf&scoped=true&"
import script from "./AdminSalesSummary.vue?vue&type=script&lang=js&"
export * from "./AdminSalesSummary.vue?vue&type=script&lang=js&"
import style0 from "./AdminSalesSummary.vue?vue&type=style&index=0&id=18b889bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b889bf",
  null
  
)

export default component.exports